export default __webpack_public_path__ + "static/media/6c.a9ad8630.png";